import {Alert, Div} from 'components';
import {Ecolors} from 'constant';
import React, {useEffect, useRef, useState} from 'react';
import {getListProduct} from 'reducer/investment';
import {apiInvestment} from 'services/apis/apiInvestment';
import {useAppSelector} from 'store/hooks';
import {widthScreen} from 'utils';
import OrderBuyStep1 from './OrderBuyStep1';
import OrderBuyStep2 from './OrderBuyStep2';
import OrderBuyStep3 from './OrderBuyStep3';

interface Props {
  setStepTimeLine: (a: number) => void;
  stepTimeLine?: number;
  initData?: any;
}

function OrderBuy({setStepTimeLine, stepTimeLine, initData}: Props) {
  // state order buy
  const I18nState = useAppSelector(state => state.languages.I18nState);
  const [product, setProduct] = useState<any>(null);
  const listProduct = useAppSelector(state => getListProduct(state));
  const [scheme, setScheme] = useState<any>(null);
  const [listScheme, setListScheme] = useState<Array<any>>([]);
  const [amount, setAmount] = useState<string>('');
  const [tellerCode, setTellerCode] = useState<string>('');
  const [beginBuyAutoStartDate, setBeginBuyAutoStartDate] =
    useState<string>('1');
  const [currentSession, setCurrentSession] = useState<any>(null);
  const [excuseTempVolumn, setExcuseTempVolumn] = useState<any>(null);
  const [bankSuperVisory, setBankSuperVisory] = useState<any>(null);
  const [orderData, setOrderData] = useState<any>({});

  // control header
  const [loading, setLoading] = useState<boolean>(false);

  const scrollViewRef = useRef<any>(null);

  useEffect(() => {
    if (initData?.product) {
      onChangeProduct(initData?.product);
    }
    if (initData?.scheme) {
      setScheme(initData?.scheme);
    }
    return () => {};
  }, [initData]);

  const onNext = () => {
    setStepTimeLine((t: number) => t + 1);
    return;
  };

  const onPre = (step?: number) => {
    setStepTimeLine((t: number) => (step ? step : t == 1 ? t : t - 1));
    if (step) {
      Promise.all([
        setProduct(null),
        setScheme(null),
        setExcuseTempVolumn(null),
        setBankSuperVisory(null),
        setCurrentSession(null),
        setAmount(''),
        setBeginBuyAutoStartDate(''),
      ]);
    }
  };

  const onScroll = (e: any) => {
    const offset = Math.round(e.nativeEvent.contentOffset.x / widthScreen) + 1;
    if (offset != stepTimeLine) {
      setStepTimeLine(offset);
    }
  };
  //

  const onExcuseTempVolumn = async () => {
    if (!product || !scheme || !amount) {
      return;
    }
    try {
      const res = await apiInvestment.excuseTempVolume({
        amount: amount.replace(/[,|.]/g, ''),
        productId: product?.id,
        productProgramId: scheme?.id,
      });
      if (res.status == 200) {
        setExcuseTempVolumn(res.data);
        return;
      }
      setExcuseTempVolumn(null);
      return;
    } catch (error: any) {
      setExcuseTempVolumn(null);
      Alert.showError({
        content: I18nState == 'vi' ? error.message : error.messageEn,
        multilanguage: false,
      });
    }
  };

  const onChangeProduct = async (e: any) => {
    setLoading(true);
    setProduct(e);
    setScheme(null);
    setAmount('');
    try {
      const res = await apiInvestment.loadProductDetails({
        id: e.id,
      });
      const ses = await apiInvestment.checkOverCurrentSession({
        productId: e.id,
      });
      const aaa = await apiInvestment.loadBuy({
        id: e.id,
      });

      if (res.status == 200) {
        setListScheme(aaa.data);
      }
      if (ses.status == 200) {
        setCurrentSession(ses.data);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const switchStep = step => {
    switch (step) {
      case 1:
        return (
          <OrderBuyStep1
            loading={loading}
            tellerCode={tellerCode}
            setTellerCode={setTellerCode}
            onNext={onNext}
            product={product}
            listScheme={listScheme}
            setListScheme={setListScheme}
            onExcuseTempVolumn={onExcuseTempVolumn}
            onChangeProduct={onChangeProduct}
            listProduct={listProduct}
            setProduct={setProduct}
            scheme={scheme}
            setScheme={setScheme}
            amount={amount}
            beginBuyAutoStartDate={beginBuyAutoStartDate}
            setBeginBuyAutoStartDate={setBeginBuyAutoStartDate}
            setAmount={setAmount}
            currentSession={currentSession}
            setCurrentSession={setCurrentSession}
            setExcuseTempVolumn={setExcuseTempVolumn}
            excuseTempVolumn={excuseTempVolumn}
            bankSuperVisory={bankSuperVisory}
            setBankSuperVisory={setBankSuperVisory}
          />
        );
      case 2:
        return (
          <OrderBuyStep2
            stepTimeLine={stepTimeLine}
            tellerCode={tellerCode}
            onNext={onNext}
            onPre={onPre}
            product={product}
            beginBuyAutoStartDate={beginBuyAutoStartDate}
            scheme={scheme}
            amount={amount}
            setOrderData={setOrderData}
            currentSession={currentSession}
            excuseTempVolumn={excuseTempVolumn}
            bankSuperVisory={bankSuperVisory}
          />
        );
      case 3:
        return (
          <OrderBuyStep3
            beginBuyAutoStartDate={beginBuyAutoStartDate}
            stepTimeLine={stepTimeLine}
            excuseTempVolumn={excuseTempVolumn}
            bankSuperVisory={bankSuperVisory}
            orderData={orderData}
            amount={amount}
            currentSession={currentSession}
            onPre={onPre}
            product={product}
            scheme={scheme}
          />
        );
      default:
        return <></>;
    }
  };

  return (
    <Div backgroundColor={Ecolors.whiteColor} width={'100%'}>
      {switchStep(stepTimeLine)}
    </Div>
  );
}

export default React.memo(OrderBuy);
